module.exports = __webpack_public_path__ + "img/1.5df5004c.png";